// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const DashboardsPage = lazy(() => import('./pages/DashboardsPage'));
const PivotExplorerPage = lazy(() => import('./pages/PivotExplorerPage'));
const PredictiveInsightsPage = lazy(() => import('./pages/PredictiveInsightsPage'));
const BiExportPage = lazy(() => import('./pages/BiExportPage'));
const ReportBuilderPage = lazy(() => import('./pages/ReportBuilderPage'));

export const AnalyticsRoutes: RouteObject = {
  path: 'analytics',
  element: <ModuleGuard moduleId="core.analytics" />,
  children: [
    { path: 'dashboards', element: <DashboardsPage />, handle: { crumb: 'Dashboards' } },
    { path: 'pivot-explorer', element: <PivotExplorerPage />, handle: { crumb: 'Pivot Explorer' } },
    { path: 'predictive-insights', element: <PredictiveInsightsPage />, handle: { crumb: 'Predictive Insights' } },
    { path: 'bi-export', element: <BiExportPage />, handle: { crumb: 'Data Export & BI' } },
    { path: 'report-builder', element: <ReportBuilderPage />, handle: { crumb: 'Report Builder' } },
  ],
};
